export default __webpack_public_path__ + "static/media/headultrasonic.6e6636a7.svg";